// extracted by mini-css-extract-plugin
export var label = "_eh-2";
export var slideContainer = "_eh-0";
export var slider = "_eh-1";